import React from "react";
import { Phone } from "lucide-react";

export default function CrisisBanner() {
  return (
    <div
      data-testid="crisis-banner"
      role="region"
      aria-label="Crisis support information"
      className="w-full bg-[var(--tb-crisis)] text-white text-sm md:text-base"
    >
      <div className="container-page py-2.5 flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-6 text-center">
        <span className="font-medium flex items-center gap-2">
          <Phone className="h-4 w-4" aria-hidden="true" />
          If you are in crisis right now
        </span>
        <span className="opacity-95">
          Call <a href="tel:999" className="underline font-semibold hover:no-underline">999</a> · Samaritans{" "}
          <a href="tel:116123" className="underline font-semibold hover:no-underline">116 123</a> · Shout text{" "}
          <a href="sms:85258" className="underline font-semibold hover:no-underline">85258</a>
        </span>
      </div>
    </div>
  );
}
